import React from 'react';
import PropTypes from 'prop-types';
import Button from '@strava/ui/Button';
import { typography } from '@strava/ui-tokens/js';
import { useActivityPublicContext } from '../../ActivityPublicContext';

const CTA = ({ children, href, onClick, modalVariant, ...props }) => {
  const { openSignUpModal } = useActivityPublicContext();

  return (
    <Button
      variant="primary"
      onClick={() => {
        onClick();
        openSignUpModal(modalVariant);
      }}
      style={{ fontWeight: typography.fontWeightDemi }}
      {...props}
    >
      {children}
    </Button>
  );
};

CTA.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string, // only used by control & variant-b
  modalVariant: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

CTA.defaultProps = {
  href: undefined
};

export default CTA;
